import { api } from "./api";

export const downloadPdf = async (resumeId) => {
  const res = await api.get(`/resumes/${resumeId}/pdf`, { responseType: "blob" });
  const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || "Resume.pdf";
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
};
